import useCustomerAdmission from '@/composables/useCustomerAdmission';
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import appGlobalStore from '@/store/appGlobal.store';
import customerStore from '@/store/customer.store.ts';

/**
 * Détermine si l'utilisateur peut effectuer des réservations, en fonction des différentes données disponibles (profil
 * utilisateur, paramètre global, etc.).
 */
export default function useBookingEnabled() {
  const { isInactive } = useCustomerAdmission();
  const { isBookingEnabled } = storeToRefs(appGlobalStore());
  const { customer } = storeToRefs(customerStore());

  return computed<boolean>(() => isBookingEnabled.value && customer.value.isBookingAllowed && !isInactive.value);
}
